/* eslint-disable react/prop-types */
import React from 'react';
import numeral from 'numeral';
import { map } from 'lodash';
import { Link } from 'react-router-dom';

export const formatShows = ({ data = [], fields = {} } = {}) =>
  map(data, show => ({
    show: show[fields.show],
    showId: show[fields.showId],
    network: show[fields.network],
    networkId: show[fields.networkId],
    bingeRate: show[fields.bingeRate],
    bingeShare: show[fields.bingeShare],
    bingers: show[fields.bingers]
  }));

export const defaultSorts = ['bingeShare'];

export const columns = [
  {
    Header: '',
    accessor: (row, i) => i + 1,
    id: 'index',
    className: 'tvt-tabular-data-table__rank'
  },
  {
    Header: 'Show',
    accessor: 'show',
    className: 'tvt-tabular-data-table__binge-show',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/show/${original.showId}`}>{value}</Link>
    )
  },
  {
    Header: 'Network',
    accessor: 'network',
    className: 'tvt-tabular-data-table__binge-network'
  },
  {
    Header: 'Binge Rate',
    accessor: 'bingeRate',
    Cell: ({ cell: { value } }) => `${numeral(value * 100).format('0.00')}%`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__binge-rate',
    sortDescFirst: true,
    sortType: 'basic',
    hoverTitle:
      'Percent of viewers who unitarily tracked 4 or more episodes in each 24-hour period'
  },
  {
    Header: 'Share of Binges',
    accessor: 'bingeShare',
    Cell: ({ cell: { value } }) => `${numeral(value * 100).format('0.00')}%`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__binge-share',
    sortDescFirst: true,
    sortType: 'basic',
    hoverTitle: 'The portion of all Binge sessions belonging to a specific show'
  },
  {
    Header: 'Total Bingers',
    accessor: 'bingers',
    Cell: ({ cell: { value } }) => numeral(value).format('0,0'),
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__binge-bingers',
    sortDescFirst: true
  }
];

export default { columns, formatShows, defaultSorts };
